import { render, staticRenderFns } from "./PerformanceTrendChart.vue?vue&type=template&id=4d0d8450"
import script from "./PerformanceTrendChart.vue?vue&type=script&lang=js"
export * from "./PerformanceTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports